<template>
  <!-- drm体验提示 -->
  <transition name="slide-fade">
    <div class="drm_ad" v-show="showTrip">
      <p class="name">{{ $t('drmAd.drm') }} <br> {{ $t('drmAd.line') }}</p>
      <div class="logo_box"><img src="https://img.gpdcloud.net/drm/drm_logo.png" alt="DRM"></div>
      <p class="text">{{ $t('drmAd.text') }}</p>

      <div class="btn_box clearfix">
        <span class="btn confirm fl" @click="confirm">{{ $t('drmAd.experience') }}</span>
        <span class="btn cancel fr" @click="cancel">{{ $t('drmAd.later') }}</span>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      showTrip: false
    }
  },
  mounted() {
    this.showTrip = true

  },
  methods: {
    confirm() {
      this.cancel()
      const url = location.href
      if (url.indexOf('test') >= 0) {
        open('http://test.gpdcloud.net:84/#/')
      } else {
        open('https://drm.gpdcloud.net/#/')
      }
    },
    getToday() {
      const time = new Date()
      const mon = time.getMonth() + 1
      const day = time.getDate()
      return mon + '/' + day
    },
    cancel() {
      this.showTrip = false
      localStorage.setItem('drm_trip_date', this.getToday())
    }
  }
}
</script>

<style lang="scss" scoped>
.drm_ad {
  position: fixed;
  bottom: 50px;
  right: 20px;
  width: 200px;
  min-height: 270px;
  background-image: url("https://img.gpdcloud.net/drm/bg.png");
  background-size: cover;
  box-shadow: -1px 0 6px rgba($color: #ccc, $alpha: 0.4);
  border-radius: 9px;
  z-index: 9999;
  background-color: rgba($color: #619d56, $alpha: 0.5);
  .name {
    color: #fff;
    font-size: 16px;
    font-family: PingFang SC;
    margin-left: 20px;
    margin-top: 30px;
    line-height: 24px;
  }
  .logo_box {
    text-align: center;
    margin-top: 50px;
    img {
      width: 56px;
    }
  }
  .text {
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333;
    line-height: 22px;
    text-align: center;
    padding: 10px;
  }
  .btn_box {
    padding: 20px;
    .btn {
      cursor: pointer;
      font-size: 14px;
      color: #619d56;
    }
    .cancel {
      color: #ccc;
    }
  }
}

/* 可以设置不同的进入和离开动画 */
/* 设置持续时间和动画函数 */
.slide-fade-enter-active {
  transition: all 0.5s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active 用于 2.1.8 以下版本 */ {
  transform: translateX(50px);
  opacity: 0;
}
</style>
